import { fetchOverlapRanks, fetchOverlapTrends } from '@intelligence/services/overlapAnalysis';
import { formatDateStr } from '@home/utils/date';
import { SortType } from '@home/enums/common';
import { buildMetricFiltersFetchParams } from '@intelligence/v3/utils/topcharts';
import { DATASOURCE_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics';

class MobileOverlapDetailsService {
  static convertFetchParams(params?: IRecord): IMobileOverlapListFetchParams {
    const metricFilters = buildMetricFiltersFetchParams([
      { metric: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE, metricValue: params?.mobile_overlap },
    ]);

    return {
      entity_type: params?.entity_type || 'mobile',
      game_ids: params?.game_ids || [],
      markets: params?.markets || [],
      iegg_genre: params?.iegg_genre || [],
      sensortower_genre: params?.sensortower_genre || [],
      appannie_genre: params?.appannie_genre || [],
      metric_filter: metricFilters,
      granularity: params?.granularity || 'monthly',
      start_date: params?.start_date || '',
      end_date: params?.end_date || '',
      metrics: [
        DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
        DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_AFFINITY,
      ],
      order_metric: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE,
      order_type: SortType.Desc,
    };
  }

  static convertResponseData(responseData?: IPaginationData<IRecord>): IPaginationData<IRecord> {
    const total = responseData?.total ?? 0;
    const list = responseData?.list || [];
    const newList = list?.map((item) => {
      const metrics = item?.metric_list || [];
      return {
        ...item,
        release_time: formatDateStr(item?.release_time),
        metric_list: metrics,
      };
    });
    return { total: total || 0, list: newList || [] };
  }

  static async fetchMobileOverlapDetailsList(params?: IRecord) {
    const newParams = MobileOverlapDetailsService.convertFetchParams(params);
    const response = await fetchOverlapRanks(newParams);
    const responseData = response?.data || {};
    const newResponseData = MobileOverlapDetailsService.convertResponseData(responseData);
    return { ...response, data: newResponseData };
  }

  static convertTrendsFetchParams(params?: any) {
    const { mobile_overlap: mobileOverlap, ...restParams } = params || {};
    const metricFilters = buildMetricFiltersFetchParams([
      { metric: DATASOURCE_METRIC_KEY_MAP.SENSORTOWER__CROSS_APP_USAGE, metricValue: params?.mobile_overlap },
    ]);

    return { ...restParams, metric_filter: metricFilters };
  }

  static async fetchMobileOverlapDetailsTrends(params?: any) {
    const newParams = MobileOverlapDetailsService.convertTrendsFetchParams(params);
    const response = await fetchOverlapTrends(newParams);
    return response;
  }
}

export default MobileOverlapDetailsService;
